import React, { useState } from 'react';
import { Calendar, CheckCircle, User, Clock, Sparkles, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { Tabs } from '../components/ui/Tabs';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png',
    isShareable: true
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: '',
    isShareable: false
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98,
    isShareable: true
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100,
    isShareable: false
  }];
  const shareableProssime = prossimePulizie.filter(p => p.isShareable);
  const shareableCompletate = pulizieCompletate.filter(p => p.isShareable);
  const totalShareable = shareableProssime.length + shareableCompletate.length;
  return <MobileLayout data-id="element-3949">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-3950">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-3951">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <Tabs className="mb-6" value={activeTab} onValueChange={id => setActiveTab(id as 'gestione' | 'opportunita')} items={[{
      id: 'gestione',
      label: 'Gestione'
    }, {
      id: 'opportunita',
      label: 'Opportunità',
      badge: totalShareable > 0 ? <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold bg-coral text-white rounded-full" data-id="element-3953">
                  {totalShareable}
                </span> : undefined
    }]} data-id="element-3952" />

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-3954">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3955">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-3956">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3957">
                    <div className="flex justify-between items-start mb-3" data-id="element-3958">
                      <div data-id="element-3959">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3960">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3961">
                          <span className="flex items-center gap-1" data-id="element-3962">
                            <Calendar size={12} data-id="element-3963" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3964">
                            <Clock size={12} data-id="element-3965" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3966">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3967">
                      <div className="flex items-center gap-2" data-id="element-3968">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3969" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3970">
                            <User size={14} className="text-muted-foreground" data-id="element-3971" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3972">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3973" />
                    </div>
                  </Link>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-3974">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3975">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-3976">
              {pulizieCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3977">
                  <div data-id="element-3978">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3979">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3980">
                      <span className="flex items-center gap-1" data-id="element-3981">
                        <Calendar size={12} data-id="element-3982" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3983">
                        <Clock size={12} data-id="element-3984" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3985">
                    <div className="flex flex-col items-end" data-id="element-3986">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3987">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3988">
                        <CheckCircle size={12} data-id="element-3989" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3990" />
                  </div>
                </Link>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <div className="mb-8" data-id="element-3991">
          <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3 flex items-center gap-1.5" data-id="element-3992">
            <Sparkles size={12} className="text-coral" data-id="element-3993" />
            Pulizie condivisibili
          </div>

          {totalShareable === 0 ? <div className="bg-white border border-border rounded-xl p-8 text-center" data-id="element-3994">
              <p className="text-sm text-muted-foreground" data-id="element-3995">
                Nessuna pulizia condivisibile al momento.
              </p>
            </div> : <div className="space-y-3" data-id="element-3996">
              {shareableProssime.map(pulizia => {
          const isInProgress = pulizia.status === 'in_corso';
          return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3997">
                    <div className="flex justify-between items-start mb-3" data-id="element-3998">
                      <div data-id="element-3999">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-4000">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-4001">
                          <span className="flex items-center gap-1" data-id="element-4002">
                            <Calendar size={12} data-id="element-4003" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-4004">
                            <Clock size={12} data-id="element-4005" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-4006">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-4007">
                      <div className="flex items-center gap-2" data-id="element-4008">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-4009" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-4010">
                            <User size={14} className="text-muted-foreground" data-id="element-4011" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-4012">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-4013" />
                    </div>
                  </Link>;
        })}

              {shareableCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-4014">
                  <div data-id="element-4015">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-4016">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-4017">
                      <span className="flex items-center gap-1" data-id="element-4018">
                        <Calendar size={12} data-id="element-4019" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4020">
                        <Clock size={12} data-id="element-4021" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-4022">
                    <div className="flex flex-col items-end" data-id="element-4023">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-4024">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-4025">
                        <CheckCircle size={12} data-id="element-4026" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-4027" />
                  </div>
                </Link>)}
            </div>}
        </div>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-4028" />
    </MobileLayout>;
}